export const COLOR_SCHEME_STORAGE_KEY = "incite:color-scheme";
export const COLOR_SCHEME_LIGHT = "light";
export const COLOR_SCHEME_DARK = "dark";

const isSupportedColorScheme = (value) =>
  value === COLOR_SCHEME_LIGHT || value === COLOR_SCHEME_DARK;

const browserStorage = () => {
  if (typeof window === "undefined") return null;

  try {
    return window.localStorage;
  } catch (_error) {
    return null;
  }
};

export const storedColorScheme = (storage = browserStorage()) => {
  if (!storage) return null;

  try {
    const value = storage.getItem(COLOR_SCHEME_STORAGE_KEY);
    return isSupportedColorScheme(value) ? value : null;
  } catch (_error) {
    return null;
  }
};

export const systemColorScheme = (matchMedia = globalThis?.window?.matchMedia) => {
  if (typeof matchMedia !== "function") return COLOR_SCHEME_LIGHT;

  try {
    return matchMedia("(prefers-color-scheme: dark)").matches
      ? COLOR_SCHEME_DARK
      : COLOR_SCHEME_LIGHT;
  } catch (_error) {
    return COLOR_SCHEME_LIGHT;
  }
};

export const resolvedColorScheme = ({
  storage = browserStorage(),
  matchMedia = globalThis?.window?.matchMedia,
} = {}) => storedColorScheme(storage) || systemColorScheme(matchMedia);

export const applyColorSchemeToDocument = (
  colorScheme,
  documentElement = globalThis?.document?.documentElement,
) => {
  if (!documentElement || !isSupportedColorScheme(colorScheme)) return;

  documentElement.dataset.inciteColorScheme = colorScheme;
  documentElement.style.colorScheme = colorScheme;
};

export const storeColorScheme = (
  colorScheme,
  storage = browserStorage(),
) => {
  if (!isSupportedColorScheme(colorScheme)) return false;

  try {
    storage?.setItem(COLOR_SCHEME_STORAGE_KEY, colorScheme);
    return Boolean(storage);
  } catch (_error) {
    return false;
  }
};

export const selectColorScheme = (
  colorScheme,
  {
    storage = browserStorage(),
    documentElement = globalThis?.document?.documentElement,
    reload = () => globalThis?.window?.location?.reload?.(),
  } = {},
) => {
  if (!isSupportedColorScheme(colorScheme)) return false;

  storeColorScheme(colorScheme, storage);
  applyColorSchemeToDocument(colorScheme, documentElement);
  reload?.();
  return true;
};

